// extracted by mini-css-extract-plugin
export var table = "_xw-0";